 import { saveSFForm } from "backend/database.jsw";

 const FORM_FIELDS = ["firstName", "lastName", "email", "phone", "company", "industry"];
 const PARAMS = ["first_name", "last_name", "email", "phone", "company", "00Ni000000CVNtm"];
 

 function setAlertMessage(message, hasTimeOut) {
     $w('#message').text = message;
     $w('#message').expand();
     if (hasTimeOut) {
         setTimeout(() => {
             $w('#message').collapse();
         }, 8000);
     }
 }

 function getTodayDate() {
     const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let currentDate = `${day}/${month}/${year}`;
    return currentDate
 }

 export async function postSFData() {
     let dataToPost = { encoding: 'UTF-8', lead_source: "web" };
     FORM_FIELDS.map((x, index) => {
         let field = "#" + x;
         dataToPost[PARAMS[index]] = $w(field).value;
     });
     dataToPost['oid'] = "00DDM000003tiqS"
     dataToPost['lead_source'] = "web"
     dataToPost['00N5d00000IoqNF'] = "20a96a8a-06ff-11ee-be77-0242ac122320"
     dataToPost['00Ni0000001ZZdP'] = "Free Media Consultation (English)"
     dataToPost['00Ni000000I2S5c'] = "AC"
     dataToPost['00Ni000000EigrR'] = "1"
     dataToPost['00Ni000000EigrQ'] = getTodayDate()
     dataToPost['00Ni0000001a3YS'] = "English"
     dataToPost['00Ni000000HbJqT'] = "ypc-marketing-latest"
     dataToPost['country_code'] = "CA"
     try {
         const response = await saveSFForm(dataToPost);
         if (response.status === 200) {
             setAlertMessage('Data Saved Successfully !!!', true);
         } else {
             setAlertMessage('Something went wrong in Submitting Form.', true);
         }
     } catch (e) {
         setAlertMessage('Something went wrong in Submitting Form.', true);
     }
 }


//  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/primeng/15.1.1/resources/primeng.css" integr
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/primeng/15.1.1/resources/components/autocomp
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/primeng/15.1.1/resources/themes/bootstrap4-l
// <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity=
// <script src="https://bcleads-form-widget-qa.ypcloud.io/leads-widget.js"></script>
// <body>
// <app-widget api-key="qa_test" form-type="TYPE_2" heading-fr="TEST HEADING French"
// sub-heading-en="TEST SUB-HEADING English" sub-heading-fr="TEST SUB-HEADING French" locale="en"
// lead-source-detail="Test Lead Source"
// lead-source-label="Offer 1 - Online Presence, Offer 2 - Priority Placement, Both Offers"
// lead-source-value="Ownr_SYNC_Offer, Ownr_IYP_Offer, Ownr_ALL_Offers" product-name="product-name-test"
// country-code="CA" first-name-visible="true" last-name-visible="true" business-name-visible="true"
// industry-visible="true" email-visible="true" contact-phone-visible="true" first-name-required="true"
// last-name-required="true" business-name-required="false" industry-required="false" button-text-en="Submit"
// button-text-fr="TESt Button Text French" policy-link-en="https://www.testdomainforypc.com/terms-of-services-
// policy-link-fr="https://www.testdomainforypc.com/terms-of-services-agreement/"
// policy-link-text-en="Term & Conditions" policy-link-text-fr="Politique de confidentialité Fr Test">
// </app-widget>
// </body>